import { Expose, Exclude, Transform } from 'class-transformer'
import { DocumentSnapshot } from 'firebase/firestore'
import { _FirebaseDocument, anyToDate } from './Models'

export type ReportEntryCategory = 'withdrawn' | 'published' | 'upcoming'
export type ReviewDecision = 'pending' | 'reviewed' | 'impactful' | 'not_applicable'

@Exclude()
export class ReportEntry extends _FirebaseDocument {
  @Expose()
  public designation: string = ''

  @Expose()
  public category: ReportEntryCategory = 'withdrawn'

  @Expose()
  public badge: string = ''

  @Expose()
  public description: string = ''

  @Expose()
  public status: string = ''

  @Expose()
  public reference_url: string | null = null

  @Expose()
  public parsed_date: string | null = null

  @Expose()
  public replaced_by: string = ''

  @Expose()
  public regulation_list_doc_id: string = ''

  @Expose()
  public review_decision: ReviewDecision = 'pending'

  @Expose()
  public review_comment: string = ''

  @Expose()
  public reviewed_by: string = ''

  @Expose()
  @Transform(anyToDate)
  public reviewed_at: Date | null = null

  collection(): string {
    return 'entries'
  }

  static fromFirebase(o: DocumentSnapshot): ReportEntry | null {
    return _FirebaseDocument._fromFirebase(ReportEntry, o)
  }
}
